import axios from 'axios';
import Environment from '../components/utils/Environment';

// Manual titles mapping for proper tab titles
const MANUAL_TITLES: { [key: string]: string } = {
  'XDOCK': 'XDOCK UI - User Manual',
  'IN02': 'IN02 UI - User Manual',
  'CAMS': 'CAMS UI - User Manual'
};

const getManual = async (manualName: string) => {
const apiURL = `${Environment.getManualAPI()}/${manualName}`;
  try {
    const response = await axios.get(apiURL, {
      responseType: 'blob',
    });
    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    const manualTitle = MANUAL_TITLES[manualName] || `${manualName} Manual`;
    
    // Debug logging
    console.log(`Opening manual: ${manualName} with title: ${manualTitle}`);
    
    // Create a more robust approach for setting tab title
    const newTab = window.open('', '_blank');
    if (newTab) {
      // Set the document title before loading content
      newTab.document.title = manualTitle;
      
      // Create a simple HTML wrapper with the title and PDF embed
      newTab.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>${manualTitle}</title>
          <style>
            body { margin: 0; padding: 0; overflow: hidden; }
            iframe { width: 100%; height: 100vh; border: none; }
          </style>
        </head>
        <body>
          <iframe src="${fileURL}" type="application/pdf"></iframe>
        </body>
        </html>
      `);
      newTab.document.close();
    }
    
  } catch (error) {
    console.error(`Error fetching manual '${manualName}':`, error);
  }
};

export { getManual };
